'use client'; // Error components must be Client Components

import * as React from 'react'
import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div role="alert" aria-live="assertive" className="flex flex-col items-center justify-center mt-20 space-y-4">
      <AlertTriangle className="h-12 w-12 text-foreground" />
      <p className="text-md text-foreground">{error.message || 'An unexpected error occurred.'}</p>
      <button
        onClick={() => reset()}
        className="px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
      >
        Try again
      </button>
    </div>
  );
} 